<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<!--Select Mode, Manual Vs. Batch-->
				<div class="OptionSelectDiv">
					<h4>Select Mode:</h4>
					<div class="RadioGrid">
						<input type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="Manual" value="Manual" />
						<label for="Manual">Manually Select Staff</label>

						<input style="margin-left: 10px" type="radio" name="SelectMode" [(ngModel)]="SelectMode" id="Batch" value="Batch" />
						<label for="Batch">Import File</label>
					</div>
				</div>

				<!--Manual Mode-->
				<div *ngIf="SelectMode == 'Manual'" class="TopMarinExtra">
					<caass-staff-digital-id-manual-mode (EmailRefresh)="onEmailRefresh()"> </caass-staff-digital-id-manual-mode>
				</div>

				<!--Batch Mode-->
				<div *ngIf="SelectMode == 'Batch'" class="TopMarinExtra">
					<caass-staff-digital-id-batch-mode (EmailRefresh)="onEmailRefresh()"> </caass-staff-digital-id-batch-mode>
				</div>

				<!--Email Log Table-->
				<div class="TopMarinExtra">
					<p-accordion>
						<p-accordionTab
							header="Email Log {{ EmailLogExpand == true ? '(Click to Collapse)' : '(Click to Expand)' }}"
							[(selected)]="EmailLogExpand"
						>
							<div>
								<caass-staff-digital-id-email-log> </caass-staff-digital-id-email-log>
							</div>
						</p-accordionTab>
					</p-accordion>
				</div>
			</div>
		</div>
	</div>
</div>
